import {
  View,
  Text,
  Image,
  StyleSheet,
  Svg, Rect, Defs, LinearGradient, Stop
} from "@react-pdf/renderer";

import { PdfHeaderCircle } from "src/assets"; // same image

const styles = StyleSheet.create({
   headerContainer: {
       padding: 0,
       position: "relative",
       overflow: "hidden",
   },

  title: {
    margin: 0,
    paddingLeft: 55,
    paddingTop: 20,
    paddingBottom: 20,
    color: "#ffffff",
    fontSize: 21,
    fontWeight: 700,
  },

  badge: {
    backgroundColor: "#00bcb4",
    color: "#ffffff",
    padding: 8,
    fontSize: 7,
    fontWeight: 700,
    textTransform: "uppercase",
    maxWidth: 130,
    position: "absolute",
    top: 0,
    right: 0,
    borderBottomLeftRadius: 6
  },

  circleImageWrapper: {
    position: "absolute",
    width: 50,
    height: 60,
    left: -5,
    top: -7
  },

  circleImage: {
    width: "100%",
    height: "100%",
    objectFit: "contain"
  }
});

const GradientBackground = () => (
  <Svg
    width="100%"
    height="100%"
    style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0 }}
    viewBox="0 0 100 100"
    preserveAspectRatio="none"
  >
    <Defs>
      <LinearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="0%">
        <Stop offset="0%" stopColor="#445363" />
        <Stop offset="35%" stopColor="#4e5963" />
        <Stop offset="65%" stopColor="#2f3942" />
        <Stop offset="100%" stopColor="#101820" />
      </LinearGradient>
    </Defs>

    <Rect x="0" y="0" width="100%" height="100%" fill="url(#grad)" />
  </Svg>
);

const CoverageHeaderPdf = () => {
  return (
    <View style={styles.headerContainer}>
      {/* Gradient Background */}
      <GradientBackground />

      {/* Decorative Circle Image */}
      <View style={styles.circleImageWrapper}>
        <Image src={PdfHeaderCircle} style={styles.circleImage} />
      </View>

      {/* Title */}
      <Text style={styles.title}>
        See Where Your Patients Are Covered
      </Text>

      {/* Badge */}
      {/*<Text style={styles.badge}>*/}
      {/*  VIEW THE FOLLOWING PAGE FOR{"\n"}*/}
      {/*  SUPPORT PROGRAM DETAILS.*/}
      {/*</Text>*/}
    </View>
  );
};

export default CoverageHeaderPdf;
